import { flow, get } from 'lodash/fp';

export const getUser = get(['user']);
export const getTrackingId = flow(getUser, get(['trackingId']));
